import { debounce } from 'lodash-es';
import {
    useEffect,
    useLayoutEffect,
    useRef,
    useState,
} from 'react';

// Hook for getting page width when user resizes window
export const useWindowSize = (delay = 200) => {
    const [
        width,
        setWidth,
    ] = useState(window.innerWidth);

    useLayoutEffect(() => {
        const handleResize = debounce(() => {
            setWidth(window.innerWidth);
        }, delay);

        window.addEventListener('resize', handleResize);

        // Set initial width in case the component mounts after a resize
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    }, [delay]);

    return width;
};

// Hook for getting previous value of a variable
export const usePrevious = (value) => {
    const ref = useRef();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
};
